export default "__VITE_ASSET__0fece6a8__"